import {POST_SCHOOL_CANDIDATE_APPEAL_CONFIRM_AND_PAY,} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {
  ExamProceedToPaymentRequestBody,
  ExamProceedToPaymentResponseBody,
} from '../../api/candidate/exam/model';

interface Input {
  onSuccess?: () => void;
  onError?: () => void;
}

interface SchoolCandidateAppealConfirmPaymentRequest extends ExamProceedToPaymentRequestBody {
  amount: number;
}

export const usePostSchoolCandidateAppealConfirmAndPay = ({onSuccess, onError}: Input) => {
  const postSchoolCandidateAppealConfirmAndPay = async (payload: SchoolCandidateAppealConfirmPaymentRequest) => {
    const res = await axiosClient.post<ExamProceedToPaymentResponseBody>(
        POST_SCHOOL_CANDIDATE_APPEAL_CONFIRM_AND_PAY,
        payload
    );

    return res.data;
  };

  return useCustomMutation(
      postSchoolCandidateAppealConfirmAndPay,
      {
        onSuccess,
        onError,
      },
      false,
      false
  );
};
